import React from "react";
import {
    Column,
    DataGrid,
    Sorting,
    Paging,
    Pager,
    LoadPanel,
    ColumnHeaderFilter,
    Selection,
} from "devextreme-react/data-grid";
class LookUpItemGrid extends React.Component {
    constructor(props) {
        super(props);
        this.selectionChanged = this.selectionChanged.bind(this);
    }
    selectionChanged = ({ selectedRowsData }) => {
        const selectedData = selectedRowsData[0];
        if (selectedRowsData.length === 1) 
            this.props.parentCallback(selectedData.itemcode);
    };
    render() {
        return (
            <div>
                <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
                    noDataText="No Data"
                    dataSource={this.props.databanck}
                    showBorders={true}
                    className={this.props.selectedItems?.length>0?"Popup-GridHeightAccordianOpen":"Popup-GridHeightAccordianClose"}
                    hoverStateEnabled={true}
                    allowColumnResizing={true}
                    allowColumnReordering={false}
                    rowAlternationEnabled={false}
                    onSelectionChanged={(e) => this.selectionChanged(e)}
                    focusedRowEnabled={true}
                    showRowLines={true}
                    showColumnLines={false}
                    keyExpr={"rowid"}
                >
                    <ColumnHeaderFilter />
                    <LoadPanel enabled={true} />
                    <Selection mode="single" />
                    <Paging defaultPageSize={10} />
                    <Sorting visible={false} />
                    <Pager
                        visible={true}
                        showPageSizeSelector={true}
                        allowedPageSizes={[10, 20, 50, 300, 500, 1000]}
                        showNavigationButtons={true}
                    />
                    <Column dataField="itemcode" caption="Item"></Column>
                    <Column dataField="itemdescription1" caption="Item Description - 1"></Column>
                    <Column dataField="itemdescription2" caption="Item Description - 2"></Column>
                    <Column dataField="oeemcode" caption="OEM Manuf Code"></Column>
                    <Column dataField="itemtype" caption="Item Type"></Column>
                    <Column dataField="available" caption="Available"></Column>
                    <Column dataField="size1" caption="Size_1"></Column>
                    <Column dataField="size2" caption="Size_2"></Column>
                </DataGrid>
            </div>
        );
    }
}
export default LookUpItemGrid;